import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { theme } from "../../components/constants/muiTheme";
import ActivateOlinAmanah from "../../components/screen/purchaseOnline/ActivateOlinAmanah";

const ActivateOlinAmanahPage = () => {
  return (
    <PageTemplate
      mainComponent={
        <ThemeProvider theme={theme}>
          <ActivateOlinAmanah />
        </ThemeProvider>
      }
      pageRole={3}
      bgColor={"gray"}
    />
  );
};

export default HOC(ActivateOlinAmanahPage);
